import { useState } from "react";
import { Button } from "../../components/Button";
import { Input } from "../../components/Form/Input";
import { forgotPassword } from "../../services";
import { Loader } from "../../components/Loader";
import { toast } from "react-toastify";
import { Navigate, useNavigate } from "react-router";
import { getAuthToken } from "../../helpers";
import { AuthShell } from "../../components/Auth/AuthShell";

const ForgotPassword = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const res = await forgotPassword({ email });
            toast(res?.data || "Reset link sent successfully", { type: "success" });
            setSent(true);
            setEmail("");
        } catch (err: any) {
            toast("Error: " + (err?.error || "Failed to send reset link"), { position: "bottom-right", type: "error" });
        } finally {
            setLoading(false);
        }
    };

    if (getAuthToken()) return <Navigate to="/" />;

    return (
        <AuthShell
            heading="Reset Password"
            subheading={sent ? "Check your inbox for instructions" : "Enter your email to receive a recovery link"}
        >
            {sent ? (
                <div className="text-center py-4">
                    <div className="w-16 h-16 rounded-2xl bg-emerald-50 flex items-center justify-center mx-auto mb-6 border border-emerald-100 shadow-sm">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 text-emerald-600">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                        </svg>
                    </div>
                    <p className="font-body text-slate-600 mb-8 leading-relaxed">
                        We've sent a password reset link to <span className="font-bold text-slate-900">your email</span>. Please follow the instructions to reset your password.
                    </p>
                    <button
                        onClick={() => navigate("/login")}
                        className="w-full py-3.5 rounded-xl font-bold bg-slate-900 text-white hover:bg-slate-800 transition-colors shadow-md shadow-slate-900/10"
                    >
                        Back to Sign In
                    </button>
                </div>
            ) : (
                <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} className="flex flex-col gap-6">
                    <Input
                        type="email"
                        label="Admin Email"
                        placeholder="e.g. admin@budgit.org"
                        value={email}
                        action={(e) => setEmail(e.target.value)}
                        autoCapitalize="none"
                        autoComplete="email"
                        autoCorrect="off"
                        isRequired
                    />
                    <Button
                        title={loading ? "Sending..." : "Send Reset Link"}
                        size="lg"
                        className="w-full !py-3.5 shadow-md shadow-primary-900/20"
                        disabled={!email || loading}
                        icon={loading ? <Loader /> : undefined}
                        action={() => { }}
                        type="submit"
                    />
                    <button
                        type="button"
                        onClick={() => navigate("/login")}
                        className="text-sm font-semibold text-slate-500 hover:text-slate-900 transition-colors flex items-center justify-center gap-2"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-4 h-4">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
                        </svg>
                        Back to sign in
                    </button>
                </form>
            )}
        </AuthShell>
    );
};

export default ForgotPassword;
